import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8adb87f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fuzhi" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { setTimeout } from 'timers'


export default /*#__PURE__*/_defineComponent({
  props: ['text'],
  setup(__props) {

const props = __props

const active = ref(false)
const show = ref(false)
const copy = () => {
  if (active.value) return
  const aux = document.createElement('input')
  aux.setAttribute('value', props.text)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  active.value = true
  const divHtml: any = document.createElement('div')
  divHtml.className = 'copy-button-toast-fixed'
  divHtml.innerHTML = t('复制成功')
  document.body.append(divHtml)
  setTimeout(() => {
    divHtml.remove()
    active.value = false
  }, 2000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    onClick: _withModifiers(copy, ["stop"]),
    class: _normalizeClass([{active:active.value},'copy-content'])
  }, _hoisted_3, 10, _hoisted_1))
}
}

})